import React from "react"
import {
	Flex,
	Text,
	Accordion,
	useAccordionActiveAccordion,
	Icon,
	Rte,
	IconTypes,
} from "@capioweb/ui-components"
import { XhtmlString } from "../../@types/CapioWeb/core"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { createMarkup } from "../../utils"
import { LocalesContext } from "../../context"
import { HEADER_HEIGHT_S, scale } from "@capioweb/ui-components/src"
import { sendAccordionClickDataLayerPush } from "../../utils/piwikPro"

export interface ContactAccordionBaseBlockItem {
	heading: StringProperty
	icon: StringProperty
	text: XhtmlString
	url?: string
	anchorId?: StringProperty
}

interface ContactAccordionItemProps extends ContactAccordionBaseBlockItem {
	activeId?: string
	setActiveId?: (id: string) => void
}

const ContactAccordionItem: React.FC<ContactAccordionItemProps> = (props) => {
	const { translate, translationKeys } = React.useContext(LocalesContext)
	const id = props.anchorId.value || props.heading.value

	const ref = React.useRef(null)

	const scrollToRef = () => {
		window.scrollTo(0, ref.current.offsetTop)
		setTimeout(() => {
			const headerOffset = scale(HEADER_HEIGHT_S) + 10
			const elementPosition = ref.current.getBoundingClientRect().top
			const offsetPosition = elementPosition + window.scrollY - headerOffset

			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth",
			})
		}, 100)
	}
	return (
		props.heading?.value && (
			<Flex
				ref={ref}
				w={1}
				flexDirection="column"
				id={props.anchorId?.value || null}
			>
				<Accordion.Header
					id={id}
					toggleLabel={`${translate(translationKeys.open)} ${
						props.heading.value
					}`}
					onClick={() => {
						props.setActiveId &&
							props.setActiveId(props.activeId === id ? null : id)
						scrollToRef()
						props.activeId !== id &&
							sendAccordionClickDataLayerPush(props.heading.value)
					}}
				>
					{props.icon.value && (
						<Icon
							icon={props.icon.value as IconTypes}
							size={4.75}
							ml={-0.875}
							my={-0.5}
						/>
					)}
					<Text
						as="h3"
						variant="headline-3"
						mb={0}
						truncate="singleLine"
						pl={1}
						pr={4}
						ml={props.icon.value ? 0 : 3.875}
					>
						{props.heading?.value}
					</Text>
				</Accordion.Header>

				<Accordion.Panel id={id}>
					<Flex
						flexDirection="column"
						pt={3}
						pb={5}
						px={{ _: 2, m: 6.5, l: 7.5 }}
					>
						<Rte>
							{props.text.value && (
								<div
									dangerouslySetInnerHTML={createMarkup(props.text.value)}
								></div>
							)}
						</Rte>
					</Flex>
				</Accordion.Panel>
			</Flex>
		)
	)
}

export { ContactAccordionItem }
